import React from "react";
import { publicConfig } from "@lululemon/ecom-core";
import { compose, composeDataMethods } from "@lululemon/mwa-utils/esm";
import {
  withLapel as wrapWithAbTesting,
  withRouteMboxManifest,
} from "@lululemon/mwa-ab-testing/esm";
import withFederatedTargetPageParameters from "./withFederatedTargetPageParameters";
import { useAbTestingDeliveryMode } from "@lululemon/mwa-ab-testing/esm/hooks/useAbTestingDeliveryMode";
import useWithResourceReadyTest from "@lululemon/ecom-personalization/src/hooks/useWithResourceReadyTest";

function withDeliveryTest() {
  // eslint-disable-next-line
  return (Component) => {
    function WithDelivery(props) {
      useAbTestingDeliveryMode(props);
      return <Component {...props} />;
    }
    return composeDataMethods(Component)(WithDelivery);
  };
}

function withResourceReadyTest() {
  // eslint-disable-next-line
  return (Component) => {
    function WithResourceReadyTest(props) {
      useWithResourceReadyTest(props);
      return <Component {...props} />;
    }
    if (typeof window !== "undefined") {
      return composeDataMethods(Component)(WithResourceReadyTest);
    } else {
      return Component;
    }
  };
}

export default function withAbTesting() {
  const manifest = {
    "/": [
      { name: "hero" },
      { name: "media-action-grid-0" },
      { name: "media-action-grid-1" },
      { name: "media-action-grid-2" },
      { name: "recommenders-carousel-0" },
      { name: "recommenders-carousel-1" },
    ],
    "/c/*": [
      { name: "site-facet-nav" },
      { name: "empty-top-content" },
      { name: "product-list" },
      { name: "promo-tile-0" },
      { name: "promo-tile-1" },
      { name: "promo-tile-2" },
      { name: "hero-cards-carousel" },
      { name: "campaign-card-carousel" },
      { name: "cdp-hero" },
      { name: "hero-cards-carousel-container" },
    ],
    "/p/*": [
      { name: "pdp-product-reviews" },
      { name: "pdp-carousel" },
      { name: "you-may-like-recommender" },
      { name: "pdp-free-shipping-copy" },
      { name: "pdp-addToBag-button" },
      { name: "story-carousel" },
      { name: "story-carousel-1" },
      { name: "story-carousel-2" },
      { name: "WWMT-abt" },
    ],
    "/search*": [
      { name: "site-facet-nav" },
      { name: "product-list" },
      { name: "product-tile" },
    ],
    "*": [
      { name: "header-banner" },
      { name: "promo-banner" },
      { name: "abt-meganav-styles" },
      { name: "redirector-mbox" },
      { name: "membership-city" },
      { name: "primary-nav-mobile" },
      { name: "primary-nav-desktop" },
      { name: "desktop-promo-block-L2" },
      { name: "mobile-promo-block-L1" },
    ],
  };

  Object.keys(manifest).forEach((route) => {
    if (route !== "/" && route !== "*") {
      // handle localized routes
      manifest[`/en-ca${route}`] = manifest[route];
    }
  });

  return (Component) => {
    return compose(
      wrapWithAbTesting({
        remotes: publicConfig?.remoteEntries || {},
        clientIds: [
          publicConfig?.launchDarkly?.personalizationClientSideId,
          publicConfig?.launchDarkly?.digitalOptimizationClientSideId,
        ],
        getAkamaiToken: (appContext) => {
          const ctx = appContext.ctx || appContext;
          return ctx?.req?.app?.locals?.getSecret(
            "tf-contenteducation-akamai-token"
          );
        },
      }),
      withDeliveryTest(),
      withFederatedTargetPageParameters(),
      withRouteMboxManifest(manifest),
      withResourceReadyTest()
    )(Component);
  };
}
